export default __webpack_public_path__ + "static/media/question_Delete.0113326a.svg";